import { AlertTriangle, Scale, Clock } from "lucide-react";

const timeline = [
  { date: "NOW · Since Nov 2025", title: "Act & Rules in force", desc: "The Data Protection Board is up and running, able to investigate and impose fines." },
  { date: "NOV 2026", title: "Consent Managers come online", desc: "Registered consent platforms go live and Consent Manager registration opens." },
  { date: "13 MAY 2027", title: "Full enforcement", desc: "Notices, security, breach reporting, people's rights and children's data all need to be in place." },
];

export const WhyNow = () => (
  <section id="why-now" className="bg-[#F7F7F8] border-y border-[#E7E7EC] py-24">
    <div className="max-w-[1120px] mx-auto px-6">
      <div className="max-w-[680px]">
        <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B32]">
          <AlertTriangle size={14} /> Why this matters now
        </span>
        <h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight leading-snug">
          India's first real data protection law is in force, with a regulator that can fine.
        </h2>
        <p className="mt-4 text-base md:text-lg text-[#5C5F6B] leading-relaxed">
          The Act covers every organisation that handles Indians' data. Non-profits are not exempt. Size and registration
          type make no difference. That makes your organisation a <b className="text-[#0B0B0F]">Data Fiduciary</b>, legally
          responsible for every record you hold: beneficiaries, staff and donors.
        </p>
      </div>

      <div className="mt-12 grid sm:grid-cols-2 gap-5 max-w-[680px]">
        <div className="rounded-[14px] border border-[#F3D3DB] bg-[#FBEAEE] p-7" data-testid="penalty-security">
          <Scale size={20} className="text-[#9E1B32]" />
          <div className="mt-3 text-4xl font-extrabold tracking-tight text-[#9E1B32]">₹250 cr</div>
          <p className="mt-2 text-sm text-[#7A1426]">Maximum penalty for a serious security lapse.</p>
        </div>
        <div className="rounded-[14px] border border-[#F3D3DB] bg-[#FBEAEE] p-7" data-testid="penalty-breach">
          <Scale size={20} className="text-[#9E1B32]" />
          <div className="mt-3 text-4xl font-extrabold tracking-tight text-[#9E1B32]">₹200 cr</div>
          <p className="mt-2 text-sm text-[#7A1426]">Penalty for not reporting a data breach.</p>
        </div>
      </div>

      <div className="mt-16">
        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#9498A3]">
          <Clock size={14} /> The clock
        </div>
        <div className="mt-6 grid md:grid-cols-3 gap-5">
          {timeline.map((t, i) => (
            <div key={t.date} className="relative rounded-[14px] border border-[#E7E7EC] bg-white p-7 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-0.5 transition-[box-shadow,transform]" data-testid={`timeline-item-${i}`}>
              <div className="text-sm font-bold text-[#F58220]">{t.date}</div>
              <h3 className="mt-2 text-lg font-semibold">{t.title}</h3>
              <p className="mt-2 text-sm text-[#5C5F6B] leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
        <p className="mt-8 text-[#5C5F6B] text-[15px] max-w-[640px]">
          Realistically, you've got about <b className="text-[#0B0B0F]">18 months</b>. That's enough time, as long as you
          start now and don't leave it until 2027.
        </p>
      </div>
    </div>
  </section>
);

export default WhyNow;
